import { render, staticRenderFns } from "./semantic_tabbar.vue?vue&type=template&id=3101ae02&scoped=true&lang=html"
import script from "./semantic_tabbar.vue?vue&type=script&lang=js"
export * from "./semantic_tabbar.vue?vue&type=script&lang=js"
import style0 from "./semantic_tabbar.vue?vue&type=style&index=0&id=3101ae02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3101ae02",
  null
  
)

export default component.exports